(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-article"]) return;
  try {
    
(() => {
  const init = scope => {
    scope.querySelectorAll('[data-journal-article]').forEach(root => {
      if (root.dataset.journalReady) return;
      root.dataset.journalReady = 'true';
      const headings = [...root.querySelectorAll('[data-journal-body] h2')].filter(heading => !heading.closest('.nb-journal-shop'));
      if (headings.length > 1) {
        const contents = root.querySelector('[data-journal-contents]');
        headings.forEach((heading,index) => {
          if (!heading.id) heading.id = root.id + '-section-' + (index + 1);
          const item = document.createElement('li'); const link = document.createElement('a'); link.href = '#' + heading.id; link.textContent = heading.textContent; item.append(link); contents.querySelector('ol').append(item);
        });
        contents.hidden = false;
      }
      const button = root.querySelector('[data-journal-share]'); const status = root.querySelector('[data-journal-share-status]');
      button.addEventListener('click',async () => {
        try {
          const shareUrl = new URL(window.location.href); shareUrl.searchParams.delete('preview_theme_id'); shareUrl.searchParams.delete('_ab'); shareUrl.searchParams.delete('_fd'); shareUrl.searchParams.delete('_sc'); shareUrl.hash = '';
          await navigator.clipboard.writeText(shareUrl.toString()); status.textContent = button.dataset.copiedLabel;
        } catch { status.textContent = button.dataset.errorLabel; }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document)); else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-brand-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = scope => scope.querySelectorAll('[data-brand-strip]').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
  const button=root.querySelector('[data-brand-toggle]');
  button.addEventListener('click',()=>{
   const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));
   button.querySelector('[data-brand-label]').textContent=paused?button.dataset.resume:button.dataset.pause;
   button.querySelector('[data-brand-icon]').textContent=paused?'▶':'Ⅱ';
  });
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-related"]) return;
  try {
    
(() => {
  const init = scope => scope.querySelectorAll('[data-related-pager]').forEach(root => {
    if (root.dataset.pagerReady) return;
    root.dataset.pagerReady = 'true';
    const items = [...root.querySelectorAll('[data-related-item]')];
    const size = Number(root.dataset.pageSize) || 6;
    const total = Math.ceil(items.length / size);
    const controls = root.querySelector('[data-related-controls]');
    const previous = root.querySelector('[data-related-prev]');
    const next = root.querySelector('[data-related-next]');
    const status = root.querySelector('[data-related-status]');
    const labels = JSON.parse(root.querySelector('[data-related-labels]').textContent);
    let page = 0;
    const show = () => {
      items.forEach((item,index) => { item.hidden = index < page * size || index >= (page + 1) * size; });
      previous.disabled = page === 0;
      next.disabled = page >= total - 1;
      status.textContent = labels.page.replace('__CURRENT__', String(page + 1)).replace('__TOTAL__', String(total));
      controls.hidden = total <= 1;
    };
    previous.addEventListener('click', () => { if (page > 0) { page--; show(); } });
    next.addEventListener('click', () => { if (page < total - 1) { page++; show(); } });
    show();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-store-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  let reviewsPromise;
  const init = (scope) => {
    scope.querySelectorAll('[data-nb-reviews]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const button = root.querySelector('[data-review-more]');
      const grid = root.querySelector('[data-review-grid]');
      const status = root.querySelector('[data-review-status]');
      const labels = JSON.parse(root.querySelector('[data-review-labels]').textContent);
      grid.querySelectorAll('.nb-review').forEach((card,index) => { card.style.animationDelay = `${index * 65}ms`; });
      let shown = grid.children.length;
      button.addEventListener('click', async () => {
        button.disabled = true;
        button.textContent = labels.loading;
        try {
          if (!reviewsPromise) reviewsPromise = fetch(root.dataset.url).then(response => {
            if (!response.ok) throw new Error('Unable to load reviews');
            return response.json();
          }).catch(error => { reviewsPromise = undefined; throw error; });
          const reviews = await reviewsPromise;
          const next = reviews.slice(shown, shown + Number(root.dataset.pageSize || 6));
          const fragment = document.createDocumentFragment();
          next.forEach((review,index) => {
            const article = document.createElement('article'); article.className = 'nb-review';
            const stars = document.createElement('span'); stars.className = 'nb-review-stars';
            stars.setAttribute('aria-label',labels.rating.replace('__RATING__',review.rating));
            stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5-review.rating);
            const text = document.createElement('blockquote'); text.textContent = review.text;
            const name = document.createElement('p'); name.className='nb-review-name'; name.textContent=review.name;
            const avatar = document.createElement('span'); avatar.className='nb-review-avatar'; avatar.setAttribute('aria-hidden','true'); avatar.textContent=review.name.trim().split(/\s+/).slice(0,2).map(part=>part[0]).join('').toUpperCase();
            const author = document.createElement('span'); author.textContent=review.name; name.replaceChildren(avatar,author);
            article.style.animationDelay=`${index * 65}ms`; article.append(stars,text,name); fragment.append(article);
          });
          grid.append(fragment); shown += next.length;
          status.textContent=labels.showing.replace('__SHOWN__',shown.toLocaleString()).replace('__TOTAL__',reviews.length.toLocaleString());
          button.hidden = shown >= reviews.length;
        } catch { status.textContent = labels.error; }
        finally { button.disabled=false; button.textContent=labels.more; }
      });
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
